import { render, staticRenderFns } from "./zombieList.vue?vue&type=template&id=bb093572&scoped=true&"
import script from "./zombieList.vue?vue&type=script&lang=js&"
export * from "./zombieList.vue?vue&type=script&lang=js&"
import style0 from "./zombieList.vue?vue&type=style&index=0&id=bb093572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb093572",
  null
  
)

export default component.exports